import styled from "styled-components";
import { connect } from "react-redux";
import React, {useState, useEffect} from 'react';

import ProfilePic from '../Shared/ProfilePic';
import ProfileDetails from '../Shared/ProfileDetails';
import EditProfileDetails from '../Shared/EditProfileDetails';
import PhotoUpload from '../Shared/PhotoUpload';
import AdvancedSearch from '../AdvancedSearch';
import ProfileInterests from '../ProfileInterests';
import Menu from './Menu';
import TopMenu from './TopMenu';
import Home from './Home';
import Seo from '../Shared/Seo';

import { getInterestedProfiles, updateProfile, clearSearchResult } from "../../store/actions";

const Container = styled.div`
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  min-height: 100dvh;
  background: var(--bg);

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

const LeftBox = styled.aside`
  position: sticky;
  top: 0;
  height: 100dvh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 28px 20px;
  background:
    radial-gradient(120% 60% at 0% 100%, rgb(247 108 108 / 0.22) 0%, transparent 60%),
    var(--navy);
  color: #fefefe;

  @media (max-width: 860px) {
    display: none;
  }
`;

const Brand = styled.a`
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #fefefe;
  text-decoration: none;
  padding: 0 8px;

  span {
    font-weight: 400;
  }
`;

const MobileHeader = styled.header`
  display: none;

  @media (max-width: 860px) {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    height: 64px;
    padding: 0 16px;
    background: var(--navy);
    color: #fefefe;

    ${Brand} {
      font-size: 19px;
      padding: 0;
    }
  }
`;

const RightBox = styled.main`
  min-width: 0;
  padding: clamp(20px, 4vw, 48px);
  animation: account-in 0.6s var(--ease-out) both;

  @keyframes account-in {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: none; }
  }
`;

const ProfilePicContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  border-radius: 18px;
  background: rgb(254 254 254 / 0.07);
  border: 1px solid rgb(254 254 254 / 0.1);

  img {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid var(--butter);
    flex: none;
  }
`;

const ProfileName = styled.span`
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 17px;
  line-height: 1.25;
  color: #fefefe;
  overflow-wrap: anywhere;
`;

const Message = styled.div`
  max-width: 560px;
  padding: 28px;
  border-radius: var(--radius-card);
  background: var(--surface-butter);
  line-height: 1.7;

  h2 {
    font-size: 22px;
  }

  a {
    font-weight: 700;
  }
`;

const MyAccount = (props) => {
  const [step, setStep] = useState('my_account');

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  if(!props.user) {
    window.location.href = "/";
    return ( <div>Thank You!!!</div>);
  } else {

    if(step === 'interests'){
      const interests = props.profile.interests;
      props.clearSearchResult();
      props.getInterestedProfiles(interests);
    }

    const isApprovedUser = props.profile.approved === true || props.profile.approved === '1';

    return (
      <Container>
        <Seo page="account"/>
        <MobileHeader>
          <Brand href="/">Vinayaka <span>Matrimony</span></Brand>
          <TopMenu setStep={setStep} activeStep={step}/>
        </MobileHeader>
        <LeftBox>
          <Brand href="/">Vinayaka <span>Matrimony</span></Brand>
          {props.profile &&
            <ProfilePicContainer>
              <ProfilePic props={ props }/>
              <ProfileName>{ props.profile.display_name }</ProfileName>
            </ProfilePicContainer>
          }
          <Menu setStep={setStep} activeStep={step}/>
        </LeftBox>
        <RightBox key={step}>
          {step === 'my_account' &&
            <Home props={ props.user }/>
          }
          {step === 'profile' &&
            <ProfileDetails props={ props }/>
          }
          {step === 'editProfile' &&
            <EditProfileDetails props={ props }/>
          }
          {step === 'photos' &&
            <div>
              <PhotoUpload props={ props } />
            </div>
          }
          {step === 'search' && isApprovedUser &&
            <AdvancedSearch props={ props }/>
          }
          {step === 'search' && !isApprovedUser &&
            <Message>
              <h2>Verification pending</h2>
              Your profile is not verified yet. We will contact you soon for the verification.
              For faster verification please contact us.
              <br/><br/>
              Call: <a href="tel:+917907300686">+91 79073 00686</a><br/>
              WhatsApp: <a href="https://wa.me/917907300686" target="_blank" rel="noreferrer">+91 79073 00686</a>
            </Message>
          }
          {step === 'interests' &&
            <ProfileInterests/>
          }
        </RightBox>
      </Container>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.userState.user,
    profile: state.profileState.profile,
    profileContacts: state.profileState.profileContacts,
  };
};

const mapDipatchToProps = (dispatch) => ({
  updateProfile: (user, profile, payload) => dispatch(updateProfile(user, profile, payload)),
  getInterestedProfiles: (uids) => dispatch(getInterestedProfiles(uids)),
  clearSearchResult: () => dispatch(clearSearchResult()),
});


export default connect(mapStateToProps, mapDipatchToProps)(MyAccount);
